import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { SupportService } from "../services/support-service";
import { AppService } from "../services/app.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";

@Component({
  selector: "app-equipments",
  templateUrl: "./equipments.component.html",
  styleUrls: ["./equipments.component.scss"],
})
export class EquipmentsComponent implements OnInit {
  examList: any;
  examList1: any;
  equipmentList: any;
  saveEquipmentList: any;
  generalvalidationMessage: any;
  equipmentinfosubmit = false;
  equipmentupdatesubmit = false;
  testCenterId = "";
  disabled = true;
  updated = true;
  editopen = false;
  selectedlang: any = [];
  saveButton = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  removeElement: any;
  Message: any = "";
  UpdateMessage = "";
  errorMessage: string;
  i = 0;
  popuptype: any = "";
  alert: any;

  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;
  @ViewChild("deletePopup") deletePopup: TemplateRef<any>;
  constructor(
    private appservice: AppService,
    private modalService: BsModalService,
    private supportService: SupportService,
    private router: Router
  ) {}

  ngOnInit() {
    if (
      localStorage.getItem("testCenterId") &&
      localStorage.getItem("testCenterId") != null
    ) {
      this.testCenterId = localStorage.getItem("testCenterId");
    } else {
      this.viewTestCenter();
    }
    this.getExams();
    this.getallequipments();
    this.getLanguage();
    this.emptyEquipmentList();
    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"]) {
        this.selectedlang = res["commonMsg"];
      }
    });
  }

  emptyEquipmentList() {
    this.saveEquipmentList = [];
    this.saveEquipmentList.push({
      testCenterId: localStorage.getItem("testCenterId"),
      examId: "",
      machine: "",
      mac: "",
      make: "",
      modelId: "",
      machineId: "",
      platform: "",
      year: "",
      available: true,
    });
  }
  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            localStorage.setItem("testCenterId", res["entity"]["id"]);
            this.testCenterId = localStorage.getItem("testCenterId");
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  private isLastEquipmentComplete() {
    const index = this.saveEquipmentList.length - 1;
    return (
      this.saveEquipmentList[index].examId &&
      this.saveEquipmentList[index].machine &&
      this.saveEquipmentList[index].mac &&
      this.saveEquipmentList[index].make &&
      this.saveEquipmentList[index].modelId &&
      this.saveEquipmentList[index].machineId &&
      this.saveEquipmentList[index].year
    );
  }

  addEquipment() {
    let valid = true;
    this.alert = "Alert";
    if (this.saveEquipmentList.length > 0 && this.saveEquipmentList) {
      if (this.isLastEquipmentComplete()) {
        valid = true;
      } else {
        valid = false;
        this.equipmentinfosubmit = true;
      }
    }

    if (valid) {
      this.saveEquipmentList.push({
        testCenterId: localStorage.getItem("testCenterId"),
        examId: "",
        machine: "",
        mac: "",
        make: "",
        modelId: "",
        machineId: "",
        platform: "",
        year: "",
        available: true,
      });
    } else {
      this.Message = "";
      this.errorMessage = this.selectedlang.addressHighlight;
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
      // this.alert = "Info";
      // this.generalvalidationMessage = this.selectedlang.addressHighlight;
      // this.openModal(this.generalvalidation);
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  getExams() {
    this.appservice.getAllExamswithoutMRAandCTA().subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.examList = res["entity"];
          if (this.examList.length > 0) {
            for (let index = 0; index < this.examList.length; index++) {
              if (this.examList[index].id === 1) {
                this.examList[index].examsname = "MRI/MRA";
              } else if (this.examList[index].id === 3) {
                this.examList[index].examsname = "CTS/CTA";
              } else {
                this.examList[index].examsname = this.examList[
                  index
                ].examshortname;
              }
            }
          }
        } else {
          this.examList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView();
  }

  getallequipments() {
    const data = {
      testCenterId: localStorage.getItem("testCenterId"),
    };

    this.appservice.getAllEquipmentsByTc(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.equipmentList = res["entity"];
          for (let index = 0; index < this.equipmentList.length; index++) {
            this.equipmentList[index].diasabled = true;
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  editInline(i) {
    if (!this.editopen) {
      this.editopen = true;
      this.equipmentList[i].diasabled = false;
    } else {
      this.alert = "Info";
      this.generalvalidationMessage = this.selectedlang.editopen;
      this.openModal(this.generalvalidation);
    }
  }

  onchangeExam(p, index) {
    let selectedexam;
    let existexam;

    for (let i = 0; i < this.examList.length; i++) {
      this.examList[i].currentExamcount = 0;
      this.examList[i].savedExamcount = 0;

      for (let j = 0; j < this.saveEquipmentList.length; j++) {
        if (+this.examList[i].id === +this.saveEquipmentList[j].examId) {
          this.examList[i].currentExamcount += 1;
        }
      }

      for (let e = 0; e < this.equipmentList.length; e++) {
        if (+this.examList[i].id === +this.equipmentList[e].exam.id) {
          this.examList[i].savedExamcount += 1;
        }
      }

      if (+p === +this.examList[i].id) {
        selectedexam = this.examList[i];
      }

      if (
        this.saveEquipmentList[index].machine &&
        this.saveEquipmentList[index].machine === this.examList[i].examsname
      ) {
        existexam = this.examList[i];
      }
    }

    setTimeout(() => {

      if (!this.saveEquipmentList[index].machine) {
        if (+selectedexam["id"] === +this.saveEquipmentList[index].examId) {
          var count =
            selectedexam.savedExamcount + selectedexam.currentExamcount;
          this.saveEquipmentList[index].mac =
            selectedexam.examsname + "#" + (count > 0 ? count : 1);
          this.saveEquipmentList[index].machine = selectedexam.examsname;
        }
      } else if (this.saveEquipmentList[index].machine) {
        const oldexam = this.saveEquipmentList[index].machine;
        var count = selectedexam.savedExamcount + selectedexam.currentExamcount;
        this.saveEquipmentList[index].mac =
          selectedexam.examsname + "#" + (count > 0 ? count : 1);
        this.saveEquipmentList[index].machine = selectedexam.examsname;
        let n = 1;
        for (let ss = 0; ss < this.saveEquipmentList.length; ss++) {
          if (oldexam === this.saveEquipmentList[ss].machine) {
            this.saveEquipmentList[ss].mac =
              oldexam + "#" + (existexam.savedExamcount + n);
            n += 1;
          }
        }
      }
    }, 800);
  }

  removebeforesaveEquipment(index) {
    if (
      index === 0 &&
      this.saveEquipmentList &&
      this.saveEquipmentList.length === 1
    ) {
      let jflag;
    } else {
      let existexam;
      const oldmachine = this.saveEquipmentList[index].machine;
      this.saveEquipmentList.splice(index, 1);
      for (let i = 0; i < this.examList.length; i++) {
        this.examList[i].currentExamcount = 0;
        for (let j = 0; j < this.saveEquipmentList.length; j++) {
          if (this.examList[i].id === this.saveEquipmentList[j].examId) {
            this.examList[i].currentExamcount += 1;
          }
        }

        this.examList[i].savedExamcount = 0;
        for (let e = 0; e < this.equipmentList.length; e++) {
          if (this.examList[i].id === this.equipmentList[e].exam.id) {
            this.examList[i].savedExamcount += 1;
          }
        }

        if (oldmachine && oldmachine === this.examList[i].examsname) {
          existexam = this.examList[i];
          break;
        }
      }

      setTimeout(() => {
        let n = 1;
        for (let ss = 0; ss < this.saveEquipmentList.length; ss++) {
          if (oldmachine === this.saveEquipmentList[ss].machine) {
            this.saveEquipmentList[ss].mac =
              oldmachine + "#" + (existexam.savedExamcount + n);
            n += 1;
          }
        }
      }, 300);
    }
  }
  removeEquipment(index) {
    const removed_elements = this.equipmentList[index];
    if (removed_elements !== null) {
      const data = {
        equipmentId: removed_elements.id,
      };
      this.appservice.removeTcEquipment(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.equipmentList.splice(index, 1);
            this.errorMessage = "";
            this.Message = this.selectedlang.equipdeleted;
          }
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.Message = "";
            this.errorMessage = this.selectedlang.norec;
          }
          if (res && res["status"] && res["status"]["status"] === 230) {
            this.Message = "";
            this.errorMessage = this.selectedlang.dataRequired;
          }
          setTimeout(() => {
            this.Message = "";
          }, 5000);
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  changeavailabletcequipment(index, available) {
    const available_elements = this.equipmentList[index];
    if (available_elements != null) {
      const data = {
        equipmentId: available_elements.id,
        available: available,
      };
      this.appservice.changeavailabletcequipment(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.equipmentList[index].available = available;
            this.Message = this.selectedlang.machineAvailble;
          }
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.Message = "";
            this.errorMessage = this.selectedlang.norec;
          }
          if (res && res["status"] && res["status"]["status"] === 230) {
            this.Message = "";
            this.errorMessage = this.selectedlang.dataRequired;
          }
          setTimeout(() => {
            this.Message = "";
            this.errorMessage = "";
          }, 5000);
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  edit(eq) {
    let valid = true;
    this.scrollTop("scrollme");
    this.alert = "Alert";
    let flag = 0;
    if (this.saveEquipmentList != null && this.saveEquipmentList.length > 0) {
      const index = this.saveEquipmentList.length - 1;
      if (this.isLastEquipmentComplete()) {
        console.log("true");
      } else {
        valid = false;
        this.saveEquipmentList.splice(index, 1);
      }
      for (let index = 0; index < this.saveEquipmentList.length; index++) {
        if (
          this.saveEquipmentList[index] !== null &&
          this.saveEquipmentList[index].examId &&
          this.saveEquipmentList[index].examId === eq.exam.id
        ) {
          this.alert = "Info";
          this.generalvalidationMessage = this.selectedlang.equipmentSelected;
          this.openModal(this.generalvalidation);
          flag = 1;
        }
      }
    }
    if (flag === 0) {
      this.saveEquipmentList.push({
        id: eq.id,
        testCenterId: localStorage.getItem("testCenterId"),
        examId: eq.exam.id,
        machine: eq.machine,
        mac: eq.mac,
        make: eq.make,
        modelId: eq.modelId,
        machineId: eq.machineId,
        platform: eq.platform,
        year: eq.year,
        available: eq.available,
      });

      return;
    } else {
      return;
    }
  }
  updateEquipment(i) {
    this.equipmentupdatesubmit = true;
    let valid = false;
    if (
      (this.equipmentList[i] &&
        this.equipmentList[i] !== null &&
        this.equipmentList[i].machineId !== null &&
        this.equipmentList[i].machineId !== "" &&
        this.equipmentList[i].make !== null &&
        this.equipmentList[i].make !== "" &&
        this.equipmentList[i].modelId !== null &&
        this.equipmentList[i].modelId !== "" &&
        this.equipmentList[i].id !== null &&
        this.equipmentList[i].id !== "") ||
      (this.equipmentList[i].platform !== null &&
        this.equipmentList[i].platform !== "" &&
        this.equipmentList[i].year !== null &&
        this.equipmentList[i].year !== "")
    ) {
      valid = true;
    } else {
      valid = false;
      this.Message = "";
      this.errorMessage = this.selectedlang.addressHighlight;
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    }

    if (valid) {
      const data = {
        eqInputs: [
          {
            testCenterId: localStorage.getItem("testCenterId"),
            id: this.equipmentList[i].id,
            examId: this.equipmentList[i].exam.id,
            mac: this.equipmentList[i].mac,
            machine: this.equipmentList[i].machine,
            make: this.equipmentList[i].make,
            modelId: this.equipmentList[i].modelId,
            machineId: this.equipmentList[i].machineId,
            platform: this.equipmentList[i].platform,
            year: this.equipmentList[i].year,
            available: this.equipmentList[i].available,
          },
        ],
      };
      this.appservice.saveTcEquipments(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.editopen = false;
            this.updated = true;
            this.equipmentupdatesubmit = false;
            this.equipmentList[i].diasabled = true;
            this.errorMessage = "";
            this.Message = this.selectedlang.equpdatedSuccessfully;
            setTimeout(() => {
              this.Message = "";
            }, 5000);
            this.getallequipments();
          }
          if (res && res["status"] && res["status"]["status"] === 230) {
            this.equipmentupdatesubmit = true;
            this.Message = "";
            this.errorMessage = this.selectedlang.addressHighlight;
            setTimeout(() => {
              this.errorMessage = "";
            }, 5000);
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }
  save() {
    this.saveButton = true;
    this.equipmentinfosubmit = true;
    let valid = false;
    this.alert = this.selectedlang.saveChgs;
    if (this.saveEquipmentList.length > 0 && this.saveEquipmentList) {
      if (this.isLastEquipmentComplete()) {
        valid = true;
      } else {
        this.saveButton = false;
        valid = false;
        this.Message = "";
        this.errorMessage = this.selectedlang.addressHighlight;
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
      }
    }
    const data = {
      eqInputs: this.saveEquipmentList,
    };
    if (valid) {
      this.appservice.saveTcEquipments(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.equipmentinfosubmit = false;
            this.emptyEquipmentList();
            this.errorMessage = "";
            this.Message = this.selectedlang.equpdatedSuccessfully;
            setTimeout(() => {
              this.Message = "";
            }, 5000);

            if (
              localStorage.getItem("subscriptionflag") !== null &&
              localStorage.getItem("subscriptionflag") === "false"
            ) {
              setTimeout(() => {
                this.router.navigate([
                  localStorage.getItem("testCode").toString().trim(),
                  "procedure",
                ]);
              }, 1500);
            }
          }

          this.saveButton = false;
          this.getallequipments();
        },
        (err) => {
          this.saveButton = false;
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  omitSpace(e, value) {
    if (!value && value.length === 0) {
      let k;
      k = e.charCode;
      if (k === 32) {
        e.preventDefault();
      }
    }
  }
  confirmationPopAfterSave(i) {
    this.i = i;
    this.alert = "Remove";
    this.popuptype = "deleteaftersave";
    this.generalvalidationMessage = this.selectedlang.popupEq;
    this.openModal(this.deletePopup);
  }
  confirmationPopBeforeSave(i) {
    this.i = i;
    this.alert = "Remove";
    this.popuptype = "deletebeforesave";
    this.generalvalidationMessage = this.selectedlang.popupEq;
    this.openModal(this.deletePopup);
  }

  triggerPopup() {
    if (this.popuptype === "deleteaftersave") {
      this.removeEquipment(this.i);
    }
    if (this.popuptype === "deletebeforesave") {
      this.removebeforesaveEquipment(this.i);
    }
    document.getElementById("closepopup").click();
  }
}
